"use client";
import { jsx, Fragment } from 'react/jsx-runtime';
import { logger } from '@ninja/utilities';
import { Checkbox } from './Checkbox2.js';
import { DatePicker } from './DatePicker2.js';
import { DatePickerRange } from './DatePickerRange2.js';
import { Dropdown } from './Dropdown2.js';
import { MultiSelectDropdown } from './Dropdown3.js';
import NumberRangeField from './NumberRangeField2.js';
import { RadioButtonGroup } from './RadioButton2.js';
import 'react';
import 'clsx';
import { RadioCard } from './RadioCard2.js';
import { TextField, NumberField } from './TextField2.js';
import FormNonEditableField from './DynamicForm4.js';
import { useFieldSchemaUpdate } from './hooks8.js';

function FormField(props) {
    var _a;
    const { field, form, columnsCount } = props;
    const schema = useFieldSchemaUpdate({ schema: props.schema, form });
    const { type, isEditable } = schema;
    if (isEditable === false) {
        const value = form.watchValues(field);
        return jsx(FormNonEditableField, { schema: schema, fieldValue: value });
    }
    if (type === 'text' || type === 'password') {
        return jsx(TextField, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'number') {
        return jsx(NumberField, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'text-area') {
        return jsx(TextField, Object.assign({}, schema, { form: form, field: field, type: "text-area" }));
    }
    else if (type === 'drop-down') {
        return (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        jsx(Dropdown, Object.assign({}, schema, { form: form, field: field })));
    }
    else if (type === 'date-picker') {
        return jsx(DatePicker, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'date-picker-range') {
        return jsx(DatePickerRange, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'multi-drop-down') {
        return (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        jsx(MultiSelectDropdown, Object.assign({}, schema, { form: form, field: field })));
    }
    else if (type === 'separator') {
        return !!columnsCount && columnsCount > 1 ? (jsx("div", { style: { gridColumn: `span ${Math.min(columnsCount, (_a = schema.columns) !== null && _a !== void 0 ? _a : 1)}` } })) : (jsx(Fragment, {}));
    }
    else if (type === 'number-range') {
        return jsx(NumberRangeField, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'custom') {
        return jsx(schema.component, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'radio-cards') {
        return jsx(RadioCard, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'radio-button') {
        return jsx(RadioButtonGroup, Object.assign({}, schema, { form: form, field: field }));
    }
    else if (type === 'checkbox') {
        return jsx(Checkbox, Object.assign({}, schema, { form: form, field: field }));
    }
    else {
        logger.error('unsupported field type', { type: type, field });
        return jsx(Fragment, {});
    }
}

export { FormField };
